<template>
  <div>
    <default-card>
      <template slot="title-left"> <span class="mt-n2 ml-n2 d-block"> {{title}} 💰 </span> </template>
      <template slot="title-right"> </template>
      <template slot="content">
        <v-alert dense v-if="totalValue == 0 && averageValue == 0" type="info" :value="true" class="mt-n1 mb-n1">
          Sem nenhum registro por enquanto
        </v-alert>
        <v-row class="d-flex justify-center pb-4 mt-n3 px-3" v-if="totalValue > 0 && averageValue > 0">
          <v-col cols="12" lg="5" md="12" class="d-flex justify-start mx-3 my-1" style="border: 0.5px solid #ddd;border-radius: 5px;">
            <div :style="icon_style" class="d-flex justify-center py-1 px-2">
              <v-icon :color="icon_color">{{icon}}</v-icon>
            </div>
            <div class="ml-1">
              <v-row>
                <v-col cols="12" lg="12" style="font-weight: 500;font-size: small;">Total</v-col>
                <v-col cols="12" lg="12" class="mt-n8" style="color: black;font-weight: bold;">{{totalValue ? formatMoney(totalValue||0) : ''}}</v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" lg="5" md="12" class="d-flex justify-start mx-3 my-1" style="border: 0.5px solid #ddd;border-radius: 5px;">
            <div :style="icon_style" class="d-flex justify-center py-1 px-2">
              <v-icon :color="icon_color">{{icon}}</v-icon>
            </div>
            <div class="ml-1">
              <v-row>
                <v-col cols="12" lg="12" style="font-weight: 500;font-size: small;">Média</v-col>
                <v-col cols="12" lg="12" class="mt-n8" style="color: black;font-weight: bold;">{{averageValue ? formatMoney(averageValue||0) : ''}}</v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </template>
      <template slot="actions"> </template>
    </default-card>
  </div>
</template>

<script>
export default {
  name: 'Received',

  props: {
    totalValue: {
      type: Number,
      default: null
    },
    averageValue: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    background_color: {
      type: String,
      default: null
    },
    icon_color: {
      type: String,
      default: 'primary'
    },
  },

  data() {
    return {
      title_class: 'primary--text overline',
    }

  },
  methods: {
    formatMoney(entry){
      return (Number(entry)/100).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
    }
  },
  computed: {
    icon_style(){
      return "background-color: "+this.background_color+";"
    }
  }
}
</script>

<style lang="scss" scoped>

</style>